import { useSearchParams } from 'react-router-dom'
import MenuSelect from '@/components/ui/MenuSelect'
import {
  SORT_OPTIONS,
  parseItemsSortParam,
  type SortOption,
} from '@/lib/itemsSort'

const triggerClass =
  'py-2 pl-2.5 pr-2 text-xs font-medium text-stone-800 sm:pl-3 sm:pr-2.5 sm:text-sm'

export default function ItemsSortSelect() {
  const [searchParams, setSearchParams] = useSearchParams()
  const sort = parseItemsSortParam(searchParams.get('sort'))

  const setSort = (nextSort: SortOption) => {
    const next = new URLSearchParams(searchParams)
    if (nextSort === 'relevance') next.delete('sort')
    else next.set('sort', nextSort)
    setSearchParams(next, { replace: true })
  }

  return (
    <MenuSelect
      value={sort}
      options={SORT_OPTIONS}
      onChange={(v) => setSort(v as SortOption)}
      ariaLabel="Sort by"
      align="right"
      className="w-[10.5rem] shrink-0 rounded-lg border border-stone-200 bg-white shadow-sm transition-colors hover:border-orange-200 hover:bg-stone-50 sm:w-[12.5rem]"
      buttonClassName={triggerClass}
    />
  )
}
